import { useDialog } from "@shared/features/dialog/useDialog";
import { useMobileMenu } from "@shared/features/mobileMenu/useMobileMenu";
import { ProgramAddCalendarEventsDialog } from "./ProgramAddCalendarEventsDialog";
import { useUserTimezoneOption } from "@platform/hooks/useUserTimezoneOption";
import { useUserCircle } from "@platform/hooks/useUserCircle";
import { programEventBus } from "../../program.events";
import { useProgram } from "../../hooks/useProgram";

export function ProgramAddCalendarEventsContainer() {
  const { activeDialog, closeDialog } = useDialog();

  const { program } = useProgram();

  const userTimezoneOption = useUserTimezoneOption();

  const { closeMobileMenu } = useMobileMenu();

  const isOpen = activeDialog === "addCalendarEvents";

  const circle = useUserCircle();

  const handleDone = async () => {
    // close the dialog
    closeDialog("addCalendarEvents");

    closeMobileMenu();
  };

  const handleAddCalendarEvent = (
    meetingId: number | "all",
    calendarType: "google" | "ical"
  ) => {
    programEventBus.emitEvent("program:addToCalendarModal:addCalendarEvent", {
      programId: parseInt(program?.id, 10),
      circleId: parseInt(circle?.id, 10),
      meetingId,
      calendarType,
    });
  };

  return (
    <ProgramAddCalendarEventsDialog
      meetings={circle?.meetings ?? undefined}
      userTimezone={userTimezoneOption ?? undefined}
      onClose={handleDone}
      onAddCalendarEvent={handleAddCalendarEvent}
      isOpen={isOpen}
    />
  );
}

export default ProgramAddCalendarEventsContainer;
